import React, { useEffect, useState } from 'react'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import { getStudentOnlineLectureOneToOneTodayListData, getStudentOnlineLectureGroupTodayListData, getStudentOnlineLectureOneToOneMonthlyListData, getStudentOnlineLectureGroupMonthlyListData } from '../../../Redux/action/StudentAction';
import { useDispatch, useSelector } from 'react-redux';
import Beatloader from '../../../Common/BeatLoader';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import MeetingFrame from '../../VideoMeet/MeetingFrame';

const StudentOnlineLecture = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [startMeet, setStartMeet] = useState(false)

    useEffect(() => {


        dispatch(getStudentOnlineLectureOneToOneTodayListData());
        dispatch(getStudentOnlineLectureGroupTodayListData());
        dispatch(getStudentOnlineLectureOneToOneMonthlyListData());
        dispatch(getStudentOnlineLectureGroupMonthlyListData());

    }, []);


    const {

        loadingStudentOnlineLectureOneToOneMonthlyApi,
        StudentOnlineLectureOneToOneMonthlyApiData,
        StudentOnlineLectureOneToOneMonthlyApiError,

        loadingStudentOnlineLectureOneToOneTodayApi,
        StudentOnlineLectureOneToOneTodayApiData,
        StudentOnlineLectureOneToOneTodayApiError,

        loadingStudentOnlineLectureGroupMonthlyApi,
        StudentOnlineLectureGroupMonthlyApiData,
        StudentOnlineLectureGroupMonthlyApiError,

        loadingStudentOnlineLectureGroupTodayApi,
        StudentOnlineLectureGroupTodayApiData,
        StudentOnlineLectureGroupTodayApiError
    } = useSelector(state => state?.StudentReducer);

    const handleJoinMeeting = (start_date, start_timeee, start_time, end_time, link, tutor_id, student_id, session_id, booked_id, meeting_provider) => {

        // Log input data

        // Parse start time
        // const [startTime, startMeridian] = start_time?.split(" ");
        // const [startHours, startMinutes] = startTime?.split(":");
        // const formattedStartHours =
        //     startMeridian === "PM" && parseInt(startHours, 10) !== 12
        //         ? parseInt(startHours, 10) + 12
        //         : startMeridian === "AM" && parseInt(startHours, 10) === 12
        //             ? 0
        //             : parseInt(startHours, 10);

        // Parse end time
        // const [endTime, endMeridian] = end_time?.split(" ");
        // const [endHours, endMinutes] = endTime?.split(":");
        // const formattedEndHours =
        //     endMeridian === "PM" && parseInt(endHours, 10) !== 12
        //         ? parseInt(endHours, 10) + 12
        //         : endMeridian === "AM" && parseInt(endHours, 10) === 12
        //             ? 0
        //             : parseInt(endHours, 10);

        // Create Date objects for start and end time
        const sessionStartDateTime = new Date(start_time);
        // sessionStartDateTime.setHours(formattedStartHours, parseInt(startMinutes, 10), 0, 0);

        const sessionEndDateTime = new Date(end_time);
        // sessionEndDateTime.setHours(formattedEndHours, parseInt(endMinutes, 10), 0, 0);

        const currentDateTime = new Date();

        // console.log('currentDateTime',currentDateTime,'sessionStartDateTime',sessionStartDateTime)

        // Determine meeting status
        if (currentDateTime < sessionStartDateTime) {
            toast.success(
                <div>Meeting starts on {start_date} {start_timeee}</div>
            );
        } else if (currentDateTime > sessionEndDateTime) {
            toast.error(
                <div>Meeting link expired</div>
            );
        } else {
            if (meeting_provider == 'gmeet') {
                window.open(link, '_blank', 'noopener,noreferrer');

            }
            else {
                // Allow joining if within valid time window
                setStartMeet(true);

                navigate(`/show-meeting`, {
                    state: {
                        authToken: localStorage.getItem('student-token'),
                        meetingLink: link,
                        end_time: end_time,
                        tutor_id: tutor_id,
                        student_id: student_id,
                        session_id: session_id,
                        booked_id: booked_id
                    },
                });
            }
        }
    };



    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Online Lecture
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="home-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#home"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                            >
                                                Today
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="profile-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="false"
                                            >
                                                Monthly
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            {loadingStudentOnlineLectureOneToOneTodayApi && loadingStudentOnlineLectureGroupTodayApi ?
                                                <Beatloader />
                                                :
                                                <div className="my-schedule-detail-sec">
                                                    {(StudentOnlineLectureOneToOneTodayApiData?.length > 0 || StudentOnlineLectureGroupTodayApiData?.length > 0) ?
                                                        <div className="row">
                                                            {StudentOnlineLectureOneToOneTodayApiData?.map((data) => (
                                                                <div className="col-lg-6 mt-3 col-md-6">
                                                                    <div className="card bg-light">
                                                                        <div className="card-header">
                                                                            <h5>Course Name: {data?.course?.name}</h5>
                                                                            <h5>Course Type: One To One</h5>
                                                                        </div>
                                                                        {data?.course?.courseSession?.map((item) => {

                                                                            return (
                                                                                <div className="card-body justify-content-center">

                                                                                    <h6>Start Date: {item?.formated_start_date}</h6>
                                                                                    <h6>Time Slot: {item?.timeslots?.formated_start_time} - {item?.timeslots?.formated_end_time} ({item?.timeslots?.timeZoneAbb}) </h6>
                                                                                    <h6>Topic Details: {item?.topic_details
                                                                                    }</h6>
                                                                                    {new Date(item?.timeslots?.new_end_date_time) >= new Date() ? (
                                                                                        <button
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                handleJoinMeeting(
                                                                                                    item?.formated_start_date,
                                                                                                    item?.timeslots?.formated_start_time,
                                                                                                    item?.timeslots?.new_start_date_time,
                                                                                                    item?.timeslots?.new_end_date_time,
                                                                                                    data?.course?.meetting_link,
                                                                                                    data?.tutor_id,
                                                                                                    data?.student_id,
                                                                                                    data?.course?.id,
                                                                                                    data?.id,
                                                                                                    data?.course?.meeting_provider,
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Join Meeting
                                                                                        </button>
                                                                                    ) : null}

                                                                                </div>)
                                                                        })}

                                                                    </div>
                                                                </div>))}


                                                            {StudentOnlineLectureGroupTodayApiData?.map((data) => (
                                                                <div className="col-lg-6 mt-3 col-md-6">
                                                                    <div className="card bg-light">
                                                                        <div className="card-header">
                                                                            <h5>Course Name: {data?.course?.name}</h5>
                                                                            <h5>Course Type: Group</h5>
                                                                        </div>
                                                                        {data?.course?.batches?.batchSession?.map((item) => {

                                                                            return (
                                                                                <div className="card-body justify-content-center">

                                                                                    <h6>Start Date: {item?.formated_start_date}</h6>
                                                                                    <h6>Time Slot: {item?.time_slot?.formated_start_time} - {item?.time_slot?.formated_end_time} ({item?.time_slot?.timeZoneAbb})</h6>
                                                                                    <h6>Topic Details: {item?.topic_details
                                                                                    }</h6>

                                                                                    {new Date(item?.time_slot?.new_end_date_time) >= new Date() ? (

                                                                                        <button className="btn btn-primary "
                                                                                            onClick={() =>
                                                                                                handleJoinMeeting(
                                                                                                    item?.formated_start_date,
                                                                                                    item?.time_slot?.formated_start_time,
                                                                                                    item?.time_slot?.new_start_date_time,
                                                                                                    item?.time_slot?.new_end_date_time,
                                                                                                    data?.course?.batches?.meetting_link,
                                                                                                    data?.tutor_id,
                                                                                                    data?.student_id,
                                                                                                    data?.course?.id,
                                                                                                    data?.id,
                                                                                                    data?.course?.batches?.meeting_provider,
                                                                                                )
                                                                                            }>Join Meeting</button>

                                                                                    ) : null}

                                                                                </div>
                                                                            )
                                                                        })}

                                                                    </div>
                                                                </div>))}

                                                        </div>
                                                        :
                                                        <div className='no-data-img'>
                                                            <img src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="profile"
                                            role="tabpanel"
                                            aria-labelledby="profile-tab"
                                        >
                                            {loadingStudentOnlineLectureOneToOneMonthlyApi && loadingStudentOnlineLectureGroupMonthlyApi ?
                                                <Beatloader />
                                                :
                                                <div className="my-schedule-detail-sec">
                                                    {(StudentOnlineLectureOneToOneMonthlyApiData?.length > 0 || StudentOnlineLectureGroupMonthlyApiData?.length > 0) ?
                                                        <div className="row">
                                                            {StudentOnlineLectureOneToOneMonthlyApiData?.map((data) => (
                                                                <div className="col-lg-6 mt-3 col-md-6">
                                                                    <div className="card bg-light">
                                                                        <div className="card-header">
                                                                            <h5>Course Name: {data?.course?.name}</h5>
                                                                            <h5>Course Type: One To One</h5>
                                                                        </div>
                                                                        {data?.course?.courseSession?.map((item) => (
                                                                            <div className="card-body justify-content-center">

                                                                                <h6>Start Date: {item?.formated_start_date}</h6>
                                                                                <h6>Time Slot: {item?.timeslots?.formated_start_time} - {item?.timeslots?.formated_end_time} ({item?.timeslots?.timeZoneAbb})</h6>
                                                                                <h6>Topic Details: {item?.topic_details
                                                                                }</h6>

                                                                                {new Date(item?.timeslots?.new_end_date_time) >= new Date() ? (

                                                                                    <button className="btn btn-primary "
                                                                                        onClick={() => {
                                                                                            handleJoinMeeting(
                                                                                                item?.formated_start_date,
                                                                                                item?.timeslots?.formated_start_time,
                                                                                                item?.timeslots?.new_start_date_time,
                                                                                                item?.timeslots?.new_end_date_time,
                                                                                                data?.course?.meetting_link,
                                                                                                data?.tutor_id,
                                                                                                data?.student_id,
                                                                                                data?.course?.id,
                                                                                                data?.id,
                                                                                                data?.course?.meeting_provider,
                                                                                            )
                                                                                        }}>Join Meeting</button>

                                                                                ) : null}
                                                                            </div>))}

                                                                    </div>
                                                                </div>))}


                                                            {StudentOnlineLectureGroupMonthlyApiData?.map((data) => (
                                                                <div className="col-lg-6 mt-3 col-md-6">
                                                                    <div className="card bg-light">
                                                                        <div className="card-header">
                                                                            <h5>Course Name: {data?.course?.name}</h5>
                                                                            <h5>Course Type: Group</h5>
                                                                        </div>
                                                                        {data?.course?.batches?.batchSession?.map((item) => (
                                                                            <div className="card-body justify-content-center">

                                                                                <h6>Start Date: {item?.formated_start_date}</h6>
                                                                                <h6>Time Slot: {item?.time_slot?.formated_start_time} - {item?.time_slot?.formated_end_time} ({item?.time_slot?.timeZoneAbb})</h6>
                                                                                <h6>Topic Details: {item?.topic_details
                                                                                }</h6>
                                                                                {new Date(item?.time_slot?.new_end_date_time) >= new Date() ? (

                                                                                    <button className="btn btn-primary"
                                                                                        onClick={() =>
                                                                                            handleJoinMeeting(
                                                                                                item?.formated_start_date,
                                                                                                item?.time_slot?.formated_start_time,
                                                                                                item?.time_slot?.new_start_date_time,
                                                                                                item?.time_slot?.new_end_date_time,
                                                                                                data?.course?.batches?.meetting_link,
                                                                                                data?.tutor_id,
                                                                                                data?.student_id,
                                                                                                data?.course?.id,
                                                                                                data?.id,
                                                                                                data?.course?.batches?.meetting_link,
                                                                                            )
                                                                                        }>Join Meeting</button>

                                                                                ) : null}

                                                                            </div>))}

                                                                    </div>

                                                                </div>))}

                                                        </div>
                                                        :
                                                        <div className='no-data-img'>
                                                            <img src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>
                                                    }
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </main>


                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default StudentOnlineLecture